exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/configuration/documentModel/documentModel.component.scss
// module id = ../../../../../src/app/configuration/documentModel/documentModel.component.scss
// module chunks = main